import store from "@/store"

class Platform {
  constructor() {
    this.container = null
    this.baseUrl = null
    this.focus = true
    this._openingMedia = null
    this._beforeState = {
      media: null,
      background: null,
      metrics: null
    }
  }
  async _init() {
    this.container = document.body
    let res = await __.device.baseUrl()
    if (!res) return false
    res = _$.splitUrl(res)
    this.baseUrl = res.origin
    if (res.port) this.baseUrl = `${res.origin}:${res.port}`
    if (!this.baseUrl) throw "Unable to get device baseUrl"

    _$.vue.$emit("platformInit", true)
    return true
  }

  /* Platform Controls */
  hide() {
    this.container && (this.container.style.visibility = "hidden")
  }
  show() {
    this.container && (this.container.style.visibility = null)
  }
  fullscreen(state) {
    if (state === true) document.getElementById("platform").style.visibility = "hidden"
    else if (state === false) document.getElementById("platform").style.visibility = null
  }
  async go(route = "/") {
    return this.toPlatform().then(data => data && _$.router.push(route))
  }
  async toPlatform() {
    if (__.platform.focus) return true

    if (!__.source.isPlatformSource()) return __.source.setByName("MAIN")
    else if (__.app.isLaunched) return __.app.close()
  }
  goBack() {
    if (store.state.routerHistory && store.state.routerHistory.from.path) return __.platform.go(store.state.routerHistory.from.path)
    return false
  }

  saveState(state) {
    if (Array.isArray(state) || !state) {
      if (!state) state = ["media", "metrics"]
      state.forEach(_state => this.saveState(_state))
    } else if (typeof state === "object") {
      this._beforeState = state
    } else {
      if (state === "metrics" && !this._beforeState.metrics) this._beforeState.metrics = Object.assign({}, __.common.tvWindowMetrics)
      if (state === "media" && !this._beforeState.background) this._beforeState.background = this.hasBackground() && _$.clone(store.state.background)
      if (state === "media" && !this._beforeState.media)
        this._beforeState.media = __.media.isActive() ? Object.assign({}, __.media.getState()) : false
    }
    return this.hasState() || false
  }
  getState(state) {
    if (!state) return this._beforeState
    else return this._beforeState[state]
  }
  hasState() {
    return Object.values(this._beforeState).some(val => _$.true(val))
  }
  popState() {
    if (!this.hasState()) return null

    const tempState = _$.clone(__.platform.getState())
    this.clearState()
    return tempState
  }
  async loadState(state) {
    try {
      if (
        ((Array.isArray(state) && state.indexOf("media") >= 0) || state === "media" || !state) &&
        (this._beforeState.media || this._beforeState.background)
      ) {
        if (this._beforeState.background && this._beforeState.media)
          await this.background(this._beforeState.background.slides, this._beforeState.media.source, this._beforeState.background.index)
        else if (!this._beforeState.background && this._beforeState.media && !this.hasBackground())
          await __.media.play(this._beforeState.media.source, this._beforeState.media.loop)
        else if (this._beforeState.background && !this._beforeState.media && !this.hasBackground())
          await this.background(this._beforeState.background.slides, null, this._beforeState.background.index)

        this.clearState(["media", "background"])
      }
      if (((Array.isArray(state) && state.indexOf("metrics") >= 0) || state === "metrics" || !state) && this._beforeState.metrics) {
        __.common.tvWindowResize(this._beforeState.metrics.el, this._beforeState.metrics.index)
        this.clearState("metrics")
      }
      return true
    } catch (err) {
      return _$.error(err)
    }
  }
  clearState(state) {
    if (!state) {
      this._beforeState = {
        media: null,
        background: null,
        metrics: null
      }
      return true
    } else if (Array.isArray(state)) {
      state.forEach(_state => this.clearState(_state))
    } else {
      this._beforeState[state] = null
      return true
    }
  }
  async focusing() {
    if (this.focus) return true
    else this.focus = true

    __.app.isLaunched = false

    this.show()
    await this.loadState()

    _$.nav.enable()
    _$.vue.$emit("actions", "play")
    _$.vue.$emit("applicationFocused", true)
  }
  async unfocusing() {
    if (!this.focus) return true
    else this.focus = false

    _$.nav.disable()
    _$.vue.$emit("actions", "pause")

    this.saveState()
    this.hide()

    await __.media.destroy()
  }
  async syncData(type = null) {
    await __.platform.pluginsSoftAbort()
    _$.nav.disable()

    if (type === "language")
      return store
        .dispatch("fetchMenu")
        .then(() => store.dispatch("fetchData"))
        .then(() => store.dispatch("live/fetchChannels"))
        .then(() => _$.vue.$emit("fetch.channels", true))
        .finally(() => _$.nav.enable())
    else if (type === "guest" || type === "device")
      return store
        .dispatch("fetchDevice")
        .then(res => __.device._assign(res))
        .then(() => store.dispatch("setLanguage"))
        .finally(() => _$.nav.enable())
    else
      return store
        .dispatch("fetchDevice")
        .then(res => (res ? __.device.update() : __.device._assign(res)))
        .then(() => store.dispatch("fetchConfig"))
        .then(() => store.dispatch("fetchLanguages"))
        .then(() => store.dispatch("setLanguage"))
        .then(() => store.dispatch("fetchMenu"))
        .then(() => store.dispatch("rss/fetchWeather"))
        .then(() => store.dispatch("rss/fetchPrayer"))
        .then(() => __.device.get("using_by") !== "DS" || _$.error("The device started as DS mode."))
        .then(res => res && store.dispatch("fetchData"))
        .then(res => (!res ? true : store.dispatch("live/fetchChannels")))
        .then(() => _$.vue.$emit("fetch.channels", true))
        .finally(() => _$.nav.enable())
  }

  /* Background Operations */
  async background(slides, media = false, index = false) {
    let promise = await _$.progress.create()

    if (!slides) {
      this.backgroundBehind(false)
      if (!media) __.media.stop().then(() => promise.resolve())
      else promise.resolve()
      return promise.done
    }

    if (!media) {
      __.media.stop().then(() => promise.resolve())
    } else {
      __.media.play(media, "background").finally(() => promise.resolve())
    }

    if (typeof slides === "string") slides = slides.split(",")

    store.commit("background", { index, slides })

    return promise.done
  }
  backgroundFront() {
    store.commit("background", {
      index: true,
      slides: store.state.background ? store.state.background.slides : []
    })
  }
  backgroundBehind(slides) {
    store.commit("background", {
      index: false,
      slides: slides === false ? [] : store.state.background ? store.state.background.slides : []
    })
  }
  hasBackground() {
    return $("#background-image-container").hasClass("background-active")
  }

  /* Opening Media */
  async hasOpeningMedia(type) {
    let payload = this._openingMedia
      ? _$.clone(this._openingMedia)
      : {
          type: __.device.config("boot_screen_type.type"),
          time: __.device.config("boot_screen_time.time"),
          path: __.device.config("boot_screen_path.path")
        }

    this._openingMedia = null

    if (!type || payload.time !== type) return false
    if (["video", "image"].indexOf(payload.type) < 0) return false

    return _$.vue.$popup[payload.type](`${payload.path}?version=${_$.random(5, "aA#")}`, payload.skip !== false)
  }
}

export default new Platform()
